/**
 * Rebuy Widget Multi-language Translation
 * Traduce dinamicamente i testi del widget Rebuy in base alla lingua del negozio
 */

(function() {
  'use strict';

  // ========================================
  // STRINGA TRADOTTA
  // ========================================
  // Arriva dai locales del tema tramite snippets/rebuy-translations.liquid
  // (chiave lar.rebuy.this_item), cosi' e' modificabile da Translate & Adapt
  // insieme a tutto il resto. Il fallback copre solo il caso in cui lo snippet
  // non sia stato reso, per esempio su una pagina che non lo include.
  const THIS_ITEM = (window.larRebuyI18n && window.larRebuyI18n.thisItem) || 'This item:';

  // ========================================
  // RILEVA LINGUA CORRENTE
  // ========================================
  function getCurrentLocale() {
    // Metodo 1: Attributo lang del tag HTML
    const htmlLang = document.documentElement.lang;
    if (htmlLang) {
      return htmlLang.split('-')[0].toLowerCase();
    }
    
    // Metodo 2: Oggetto Shopify.locale (disponibile in Markets)
    if (window.Shopify && window.Shopify.locale) {
      return window.Shopify.locale.toLowerCase();
    }
    
    // Metodo 3: Parsing del pathname per theme multilingua legacy
    const pathParts = window.location.pathname.split('/');
    if (pathParts[1] && pathParts[1].length === 2) {
      return pathParts[1].toLowerCase();
    }
    
    // Fallback
    console.warn('Rebuy Translations: Impossibile rilevare la lingua, uso EN come default');
    return 'en';
  }

  // ========================================
  // FUNZIONE DI TRADUZIONE
  // ========================================
  function translateRebuyLabels() {
    const locale = getCurrentLocale();
    
    // Debug info (rimuovi in produzione se non serve)
    console.log('Rebuy Translations: Lingua rilevata -', locale);
    
    // Traduci "This item:"
    const labels = document.querySelectorAll('strong.rebuy-product-label');
    
    let translatedCount = 0;
    labels.forEach(label => {
      const originalText = label.textContent.trim();
      
      // 'This item:' e' il testo che Rebuy rende di suo; il confronto con
      // THIS_ITEM evita di riscrivere una label gia' tradotta a ogni mutazione.
      if (originalText === 'This item:' || originalText === THIS_ITEM) {
        label.textContent = THIS_ITEM;
        translatedCount++;
      }
    });
    
    if (translatedCount > 0) {
      console.log(`Rebuy Translations: ${translatedCount} label tradotte`);
    }
  }

  // ========================================
  // MUTATION OBSERVER
  // ========================================
  // Monitora il DOM per intercettare quando Rebuy carica i suoi widget
  const observer = new MutationObserver((mutations) => {
    let shouldTranslate = false;
    
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        // Verifica solo nodi di tipo Element
        if (node.nodeType === 1) {
          // Controlla se il nodo è un elemento Rebuy o lo contiene
          if (node.classList && (
              node.classList.contains('rebuy-widget') ||
              node.classList.contains('rebuy-product-block') ||
              node.classList.contains('rebuy-cart')
          )) {
            shouldTranslate = true;
          }
          
          // Controlla anche nei figli
          if (node.querySelector && node.querySelector('.rebuy-product-label')) {
            shouldTranslate = true;
          }
        }
      });
    });
    
    if (shouldTranslate) {
      // Piccolo delay per assicurarsi che Rebuy abbia finito il rendering
      setTimeout(translateRebuyLabels, 100);
    }
  });

  // ========================================
  // INIZIALIZZAZIONE
  // ========================================
  function init() {
    // Avvia l'observer sul body
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Traduci elementi già presenti al caricamento
    translateRebuyLabels();
    
    // Listener per eventi Rebuy (se disponibili)
    document.addEventListener('rebuy:cart.change', translateRebuyLabels);
    document.addEventListener('rebuy:product.added', translateRebuyLabels);
    
    console.log('Rebuy Translations: Inizializzato');
  }

  // Avvia quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();